window.VegasCart = {
	add: function ($product, lparams = {}, callback) {
		let params = Object.assign({
			id: $product.data('id'),
			_token: App.csrf
		}, lparams);

		let $options = $product.find('[data-options]');
		if ($options.length) {
			params.with_options = true;
			params.options = $options.find('.option input[type="checkbox"]:checked').map(function () {
				return $(this).val();
			}).toArray();
		}

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);

				$(`[data-product][data-id="${params.id}"]`).addClass('in-cart');
				$(`[data-cart-product][data-id="${params.id}"]`).addClass('in-cart');
				$(`[data-serie-product][data-id="${params.id}"]`).addClass('in-cart');

				if (typeof callback == 'function') {
					callback(data);
				}
			} else {
				if (data.error_type === 'options_required') {
					console.log('show options modal')

					$.get(`/lyuki/${params.id}/_modal_options`, {}, function (data) {
						let $mContainer = $('.modals-container');
						$mContainer.find('#modal-product-options').remove();
						$mContainer.append(data.view);
						$mContainer.find('#modal-product-options').modal('show');
					});
				} else {
					alert(data.error_message);
				}
			}
		});
	},
	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	remove: function ($product, lparams = {}, callback) {
		let params = Object.assign({
			id: $product.data('id'),
			pivot_id: $product.data('pivot_id'),
			_token: App.csrf
		}, lparams);

		this.removeRequest(params, function (data) {
			if (!data.error) {
				$(`[data-product][data-id=${params.id}]`).removeClass('in-cart');
				$(`[data-cart-product][data-id=${params.id}]`).removeClass('in-cart');
				$(`[data-serie-product][data-id=${params.id}]`).removeClass('in-cart');

				VegasCart.total(data);

				if (typeof callback == 'function') {
					callback(data);
				}
			}
		});
	},
	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeProductDataRequest: function ($product, lparams, callback) {
		let params = Object.assign({
			_token: App.csrf,
			id: $product.data('id'),
			pivot_id: $product.data('pivot_id'),
		}, lparams);

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);

			if (!data.error) {
				VegasCart.total(data);
			}
		});
	},

	changeCnt: function ($product, params, callback) {
		this.changeProductDataRequest($product, params, callback);
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter="products-count"]').attr('data-cnt', data.products_count);
		}

		if (typeof data.cart_sum !== 'undefined') {
			$('[data-cart][data-counter="cart-total"]').text(output_roubles(data.cart_sum));
		}
	},
};

$(document).ready(function () {
	$(document).on('click', '[data-product] [data-cart][data-action="add"]', function () {
		let $product = $(this).closest('[data-product]');

		VegasCart.add($product);

		return false;
	});

	$(document).on('click', '[data-product] [data-cart][data-action="del"]', function () {
		let $product = $(this).closest('[data-product]');

		VegasCart.remove($product);

		return false;
	});

	$(document).on('click', '[data-product-options-modal] [data-cart][data-action="add"]', function () {
		let $product = $(this).closest('[data-product-options-modal]');

		VegasCart.add($product);

		$product.modal('hide');

		return false;
	});

	$(document).on('click', '[data-serie-product] [data-cart][data-action="add"]', function () {
		let $product = $(this).closest('[data-serie-product]');

		VegasCart.add($product);

		return false;
	});
	$(document).on('click', '[data-serie-product] [data-cart][data-action="del"]', function () {
		let $product = $(this).closest('[data-serie-product]');

		VegasCart.remove($product);

		return false;
	});

	// изменение кол-ва товара в корзине
	$(document).on('change-counter', '[data-cart-product] [data-toggle="input-counter"]', function () {
		let $product = $(this).closest('[data-cart-product]'),
			params = getFormData($("#form-cart"));

		params.cnt = $(this).find('input').val();

		VegasCart.changeCnt($product, params, function (data) {
			if (data.product_sum) {
				$product.find('.price-total').html(data.product_sum_formatted);
			}
		});
	});

	// удаление товара из корзины
	$(document).on('click', '[data-cart-product] [data-cart][data-action=remove]', function () {
		let $product = $(this).closest('[data-cart-product]');

		if (confirm('Вы действительно хотите убрать товар из корзины?')) {
			VegasCart.remove($product, {}, function (data) {
				$product.remove();

				if (!data.products_count) {
					location.reload();
				}
			});
		}

		return false;
	});

	$(document).on('input change', '.vg-shop-cart .promocode #promo_code', function () {
		let params = {
			code: $(this).val()
		};

		let $container = $(this).closest('.promocode');

		$.get('/cart/check_promocode', params, function (data) {
			$container.find('.success-msg, .error-msg').hide();

			if (data.error) {
				$container.find('.error-msg').html(data.msg).show();
			} else {
				$container.find('.success-msg .discount').html(data.discount).show();
				$container.find('.success-msg').show();
				$container.find('.set-promocode').show();
			}
		});

		return false;
	});
});